import { Injectable } from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/internal/operators/tap";
import { ProfileService } from "../profile-service/profile.service";
import jwt_decode from "jwt-decode";

@Injectable({
  providedIn: "root",
})
export class CanActivateService  {
  constructor(
    private userAuth: AuthService,
    private profileService: ProfileService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.userAuth.isAuthenticated$.pipe(
      tap((loggedIn) => {
        if (!loggedIn) {
          this.userAuth.login(state.url);
        } else {
          this.userAuth.getTokenSilently$().subscribe((tokenRes) => {
            const token = jwt_decode(tokenRes);
            if (token["http://allegion.com/claims/user_type"] === "external") {
              this.router.navigate(["/access-denied"]);
            }
          });
        }
      })
    );
  }
}
